<template>
    <div>
        <el-button type="primary"
                   @click="startStuleTour"
                   :disabled="!tourAvailable">
            {{$t('externalTranslationTour.tourName')}}
        </el-button>

        <el-tour v-model="tourStart"
                 :target-area-clickable="false">

            <el-tour-step :target="enableExternalTranslationsTarget"
                          :title="$t('externalTranslationTour.enableExternalTranslations')">
                <div>
                    {{$t('externalTranslationTour.enableExternalTranslationsDescription')}}
                </div>
            </el-tour-step>

            <el-tour-step :target="selectTranslationProviderTarget"
                          :title="$t('externalTranslationTour.selectTranslationProvider')">
                <div>
                    {{$t('externalTranslationTour.selectTranslationProviderDescription')}}
                </div>
            </el-tour-step>

            <el-tour-step :target="variantsButtonTarget"
                          :title="$t('externalTranslationTour.variantsButton')">
                <div>
                    {{$t('externalTranslationTour.variantsButtonDescription')}}
                </div>
            </el-tour-step>

            <el-tour-step :target="variantsButtonTarget"
                          :title="$t('externalTranslationTour.loadExternalTranslations')"
                          :content-style="loadExternalTranslationsStyle"
                          placement="left">

                <div>
                    {{$t('externalTranslationTour.loadExternalTranslationsDescription')}}
                </div>

                <img class="screenshot"
                     src="@/images/Tours/load-external-translation.png"
                     alt="tour.png" />
            </el-tour-step>

            <el-tour-step :target="variantsButtonTarget"
                          :title="$t('externalTranslationTour.selectExternalTranslation')"
                          :content-style="selectExternalTranslationStyle"
                          placement="left">

                <div>
                    {{$t('externalTranslationTour.selectExternalTranslationDescription')}}
                </div>

                <img class="screenshot"
                     src="@/images/Tours/use-external-translation.png"
                     alt="tour.png" />
            </el-tour-step>

        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                tourStart: false,

                enableExternalTranslationsTarget: "#use-external-translations",
                selectTranslationProviderTarget: "#translation-providers",
                variantsButtonTarget: "#variants-button",
                loadExternalTranslationsStyle: { width: '800px' },
                selectExternalTranslationStyle: { width: '1000px' },
            };
        },

        methods: {
            async startStuleTour() {
                await this.openCollapse();
                this.tourStart = true;
            },

            async openCollapse(){
                const element = document.getElementById("configuration-colapse");

                if(element == null){ return; }

                if(element.classList.contains("is-active")){ return; }

                // The collapse toggle is the header (a div[role="button"]), not a <button>.
                const header = element.querySelector<HTMLElement>(".el-collapse-item__header");
                if(header == null){ return; }

                header.click();

                // is-active is added at the start of the expand animation, so wait for
                // the transition to finish before the tour measures the target.
                await this.waitForExpand(element);
            },

            waitForExpand(element: HTMLElement){
                return new Promise<void>((resolve) => {
                    const wrap = element.querySelector(".el-collapse-item__wrap");
                    if(wrap == null){ resolve(); return; }

                    let done = false;
                    const finish = () => {
                        if(done){ return; }
                        done = true;
                        wrap.removeEventListener("transitionend", finish);
                        resolve();
                    };

                    wrap.addEventListener("transitionend", finish);
                    // Fallback in case the transition is skipped (e.g. reduced motion).
                    setTimeout(finish, 400);
                });
            }
        }

    })

</script>

<style scoped>
    .screenshot {
        max-width: 100%;
        margin-top: 10px;
    }
</style>
